export const languages = {
  languageDataHandler(data, lang, textInputProps) {
    const arr = [];
    let key = {}
    let ids = {}
    const langData = process.env.REACT_APP_LANGUAGES.split(', ');
    const name = {
      am: 'armenian',
      en: 'english',
      ru: 'russian',
      fr: 'french',
    };

    langData.forEach((item) => {
      key[item] = textInputProps?.labelIds[item]
      ids[item] = textInputProps?.inputIds[item]
    })

    langData.forEach((item) => {
      if (data && lang) {
        arr.push({
          selectedLanguage: item,
          title: data[name[item]][lang],
          src: `../assets/icons/languageIcon/${name[item]}.svg`,
          htmlFor: key[item],
          id: ids[item],
        });
      }
    });
    return arr;
  }
}

export function detectLanguage() {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const browserLang = navigator.language?.split('-')[0]?.toLowerCase();

  if (tz === 'Asia/Yerevan') return 'am';
  if (tz?.includes('Moscow') || tz === 'Europe/Samara') return 'ru';
  if (tz === 'Europe/Paris') return 'fr';

  if (browserLang === 'hy') return 'am';
  if (browserLang === 'ru') return 'ru';
  if (browserLang === 'fr') return 'fr';

  return 'en';
}

export function detectCurrency() {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return tz === 'Asia/Yerevan' ? 'AMD' : 'USD';
}